import { Bytes, Contract, Numbers } from 'web3';

const FLOW_ABI: any = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_token',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_minAllowance',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: '_innerInput',
        type: 'bytes',
      },
    ],
    name: 'approvalBased',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes',
        name: 'input',
        type: 'bytes',
      },
    ],
    name: 'general',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

const flow = new Contract(FLOW_ABI);

export interface ApprovalBasedPaymasterInput {
  type: 'ApprovalBased';
  token: string;
  minimalAllowance: Numbers;
  innerInput: Bytes;
}
export interface GeneralPaymasterInput {
  type: 'General';
  innerInput: Bytes;
}
export type PaymasterInput =
  | ApprovalBasedPaymasterInput
  | GeneralPaymasterInput;

export type PaymasterParams = {
  paymaster: string;
  paymasterInput: Bytes;
};

export function getApprovalBasedPaymasterInput(
  paymasterInput: ApprovalBasedPaymasterInput
): Bytes {
  return (flow as any).methods
    .approvalBased(
      paymasterInput.token,
      paymasterInput.minimalAllowance,
      paymasterInput.innerInput
    )
    .encodeABI();
}

export function getGeneralPaymasterInput(
  paymasterInput: GeneralPaymasterInput
): Bytes {
  return (flow as any).methods.general(paymasterInput.innerInput).encodeABI();
}

export function getPaymasterParams(
  paymasterAddress: string,
  paymasterInput: PaymasterInput
): PaymasterParams {
  if (paymasterInput.type == 'General') {
    return {
      paymaster: paymasterAddress,
      paymasterInput: getGeneralPaymasterInput(paymasterInput),
    };
  } else {
    return {
      paymaster: paymasterAddress,
      paymasterInput: getApprovalBasedPaymasterInput(paymasterInput),
    };
  }
}
